import { ChevronDown } from "lucide-react";
import React, { useRef, useEffect, useState } from "react";
import ReactDOM from "react-dom";

const CustomDropdown = ({ options, value, onChange, placeholder, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownStyle, setDropdownStyle] = useState({});
  const triggerRef = useRef(null);

  useEffect(() => {
    if (isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setDropdownStyle({
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (triggerRef.current && !triggerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const dropdown = (
    <div
      style={{
        position: "absolute",
        top: dropdownStyle.top,
        left: dropdownStyle.left,
        width: dropdownStyle.width,
        zIndex: 99999,
      }}
      className="bg-white border border-slate-200 rounded-xl shadow-xl overflow-hidden"
    >
      <div className="max-h-[250px] overflow-y-auto">
        {options?.map((option, index) => (
          <div
            key={index}
            className="px-4 py-3 cursor-pointer text-[#1A1C1E] hover:text-[#036EA4] hover:bg-[#F0F9FF]"
            onMouseDown={(e) => {
              e.preventDefault();   // prevents trigger blur/re-open
              e.stopPropagation();  // stops bubbling
              onChange(option);
              setIsOpen(false);
            }}
          >
            {t(option)}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="relative w-full max-w-[800px]">
      <div
        ref={triggerRef}
        onClick={() => setIsOpen(!isOpen)}
        className="w-full p-4 bg-white rounded-lg text-[#475569] flex justify-between items-center cursor-pointer"
        style={{ boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)" }}
      >
        <span>{value ? t(value) : placeholder}</span>
        <span className={`transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}>
          <ChevronDown className="text-[#475569] w-4 h-4" />
        </span>
      </div>

      {isOpen && ReactDOM.createPortal(dropdown, document.body)}
    </div>
  );
};

export default CustomDropdown;